import { createSelector } from 'reselect'
import { getPageParams, getPageData } from 'selectors/page'
import { getUserID, isAuthenticated as getIsAuthenticated } from 'selectors/user/session'
import { getHitsResults } from './algolia'

export const getIsBlackout = createSelector(
  [getPageData],
  (pageData): boolean => pageData.isBlackout
)
export const getIsUsersArtworksAccount = createSelector(
  [getPageParams, getUserID, getIsAuthenticated],
  (params, userId, isAuthenticated): boolean =>
    (isAuthenticated && Number(userId) === Number(params.userId || 0)) || false
)
export const getFirstArtworkImageUrl = createSelector(getHitsResults, (hitsResults): string => {
  const image = hitsResults && hitsResults[0] ? hitsResults[0].imageUrl : ''
  return image
})
export const getMetaData = createSelector(
  [getFirstArtworkImageUrl],
  (artworkImageUrl): Record<string, any> => {
    const title = `Curated Deals | Saatchi Art`
    const description = `Every week, shop new curator-approved original artworks from our bestselling artists offered at reduced, limited-time prices.`
    return {
      title,
      description,
      og: {
        description,
        title,
        type: 'product',
      },
      preloadImages: [artworkImageUrl],
      robots: true,
      schema: {
        webpage: {
          description,
          headline: title,
        },
      },
    }
  }
)
